import { PageHeader } from "@justworkshr/milo-components";
import styles from "./SBCInvoice.module.css";
import sbcInvoice from "assets/sample_documents/sample_sbc.pdf";

const SBCInvoice = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <PageHeader
        title="What does this document contain?"
        className={styles.headerContainer}
      />
      <div className={styles.listItem}>
        Summary of Benefits and Coverage (SBC) should contain:
        <ul>
          <li>Plan name & description</li>
          <li>Plan type (HMO, PPO, EPO)</li>
          <li>Individual/family deductibles</li>

          <li>Coinsurance</li>
          <li>Out of pocket maximum</li>
          <li>Plan year</li>
          <li>In and OON coverage</li>
          <li>Network</li>
        </ul>
      </div>
      <iframe
        title="current_invoice"
        src={sbcInvoice}
        width="100%"
        height="500px"
      />
    </div>
  );
};
export default SBCInvoice;
